import { defineMessages } from 'react-intl';

export default defineMessages({
    privacyPolicyStatement: {
        id: 'ml.quoteandbind.common.YourInfo.See our',
        defaultMessage: 'See our '
    },
    privacyPolicy: {
        id: 'ml.quoteandbind.common.YourInfo.Privacy Policy',
        defaultMessage: 'Privacy Policy'
    },
    privacyPolicyContent: {
        id: 'ml.quoteandbind.common.YourInfo.privacyPolicy.content',
        defaultMessage: 'Notice of insurance information practices – personal information about you, including information from a credit or other investigative report, may be collected from persons other than you in connection with this application for insurance and subsequent amendments and renewals. Such information as well as other personal and privileged information collected by us or our agents may in certain circumstances be disclosed to third parties without your authorization. Credit scoring information may be used to help determine either your eligibility for insurance or the premium you will be charged. We may use a third party in connection with the development of your score. You have the right to review your personal information in our files and can request correction of any inaccuracies. A more detailed description of your rights and our practices regarding such information is available.'
    },
    collectionofPersonalInfo: {
        id: 'ml.quoteandbind.common.YourInfo.privacyPolicy.Personal Information Use',
        defaultMessage: 'Personal Information Use'
    },
    doNotSell: {
        id: 'ml.quoteandbind.common.YourInfo.privacyPolicy.doNotSell',
        defaultMessage: 'Do Not Sell/Share My Information'
    },
    linksForMoreInformation: {
        id: 'ml.quoteandbind.common.YourInfo.privacyPolicy.links for more information',
        defaultMessage: ' links for more information'
    }
});
